import { Eye, ChevronDown } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const PartnersTab = ({ partners, updateStatus, setViewingPartner }) => (
  <div className="bg-white border border-[#E6E4DD]">
    <div className="p-6 border-b border-[#E6E4DD]"><h2 className="font-medium text-[#1C1C1A]">Partner Applications</h2></div>
    <div className="overflow-x-auto">
      <table className="admin-table">
        <thead><tr><th>Business</th><th>Contact</th><th>Type</th><th>Status</th><th>Actions</th></tr></thead>
        <tbody>
          {partners.map(p => (
            <tr key={p.id}>
              <td><p className="font-medium">{p.business_name}</p><p className="text-xs text-[#6B6A65]">{p.contact_person}</p></td>
              <td><p className="text-sm">{p.email}</p><p className="text-xs text-[#6B6A65]">{p.phone}</p></td>
              <td className="text-sm">{p.business_type || '-'}</td>
              <td><span className={`px-2 py-1 text-xs ${p.status === 'approved' ? 'bg-green-100 text-green-800' : p.status === 'rejected' ? 'bg-red-100 text-red-800' : 'bg-yellow-100 text-yellow-800'}`}>{p.status}</span></td>
              <td>
                <div className="flex items-center gap-2">
                  <button onClick={() => setViewingPartner(p)} className="p-2 hover:bg-[#F7F5F0]" data-testid={`view-partner-${p.id}`}><Eye size={16} /></button>
                  <DropdownMenu>
                    <DropdownMenuTrigger className="p-2 hover:bg-[#F7F5F0]"><ChevronDown size={16} /></DropdownMenuTrigger>
                    <DropdownMenuContent>
                      <DropdownMenuItem onClick={() => updateStatus('partners', p.id, 'approved')}>Approve</DropdownMenuItem>
                      <DropdownMenuItem onClick={() => updateStatus('partners', p.id, 'rejected')}>Reject</DropdownMenuItem>
                    </DropdownMenuContent>
                  </DropdownMenu>
                </div>
              </td>
            </tr>
          ))}
          {partners.length === 0 && <tr><td colSpan={5} className="text-center py-12 text-[#6B6A65]">No partner applications yet.</td></tr>}
        </tbody>
      </table>
    </div>
  </div>
);

export default PartnersTab;
